module.exports = __webpack_public_path__ + "static/img/celoscope-2.7d00ebc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/celoscopepic/celoscope-2.jpg
// module id = ogqJ
// module chunks = 51